import I18n from '@i18n';
import { Component } from 'preact';

class I18N extends Component {
  state = {
    lang: 'en',
  };
  getChildContext() {
    return {
      changeLocale: lang => {
        I18n.changeLocale(lang);
      },
      lang: this.state.lang,
    };
  }
  componentDidMount() {
    I18n.on('change', lang => {
      this.setState({ lang });
    });
  }
  render({ children }) {
    return children[0];
  }
}

export default I18N;



// WEBPACK FOOTER //
// ./utils/i18n.js